import { formatDate } from './format-date.util';

const DEFAULT_DATE_PREFIX = 'Le ';
const DEFAULT_TIME_PREFIX = ' à ';
const DEFAULT_DATE_FORMAT = undefined;
const DEFAULT_TIME_FORMAT = "HH'h'mm':'ss";

export const formatDateTime = (
  date: Readonly<string | Date>,
  {
    datePrefix = DEFAULT_DATE_PREFIX,
    timePrefix = DEFAULT_TIME_PREFIX,
    dateFormat = DEFAULT_DATE_FORMAT,
    timeFormat = DEFAULT_TIME_FORMAT,
  }: {
    datePrefix?: string;
    timePrefix?: string;
    dateFormat?: string;
    timeFormat?: string;
  } = {
    datePrefix: DEFAULT_DATE_PREFIX,
    timePrefix: DEFAULT_TIME_PREFIX,
    dateFormat: DEFAULT_DATE_FORMAT,
    timeFormat: DEFAULT_TIME_FORMAT,
  },
) =>
  `${datePrefix}${formatDate(date, dateFormat)}${timePrefix}${formatDate(date, timeFormat)}`;
